import React from "react";
import { Link } from "react-router-dom";
import { Truncate } from "@re-dev/react-truncate";
import { TbArrowBackUp } from "react-icons/tb";
import LoadingSpinner from "../../../components/LoadingSpinner";

export const BundleListingsView = ({
  bundleListingsById,
  loader,
  onBack,
  onEdit,
}) => {
  return (
    <>
      <div
        className="m-3 d-flex justify-content-between"
        onClick={onBack}
      >
        <TbArrowBackUp
          style={{ fontSize: "32px", cursor: "pointer" }}
          className="back-arrow-new shadow me-2 mb-3 rounded-5 p-1 arrow-button"
        />
        <button
          className="btn grey-btn"
          onClick={() => onEdit(bundleListingsById)}
        >
          Edit
        </button>
      </div>

      <div className="my-listings mt-5 ml-3 mb-5">
        <h3>{bundleListingsById?.title} Mockups</h3>
        <div className="row">
          {loader ? (
            <div className="d-flex justify-content-center mt-5">
              <LoadingSpinner color="#FF3E1F" />
            </div>
          ) : (
            bundleListingsById?.listings.map((item) => (
              <div className=" col-6 col-lg-3 mb-4" key={item.id}>
                <div className="listing-card card shadow p-2">
                  <div className="listing-img overflow-hidden">
                    <Link
                      to={`/mockup?id=${item?.id}`}
                      className="card-img-wrapper position-relative"
                    >
                      <img
                        src={
                          item?.use_main_file_as_thumbnail
                            ? item?.compressed_file
                            : item?.thumbnails?.[0]?.image
                        }
                        className="card-img-top rounded-tr-lg"
                        alt="Product 1"
                      />
                    </Link>
                  </div>
                  <div
                    className="listing-content pt-2"
                    style={{ minHeight: "100px" }}
                  >
                    <h6 className="testelips fw-bold">{item?.title}</h6>
                    <Truncate lines={2} style={{ fontSize: "14px" }}>
                      {item?.short_description}
                    </Truncate>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

